<template>
  <inertia-link href="/">
    <h1 class="text-2xl text-vice-teal-700 font-semibold leading-tight">
      Virtual Clinical Experiences
    </h1>
  </inertia-link>
</template>
